import { useEffect } from 'react';
import { useMap } from 'react-map-gl';

/**
 * Listens for map container size changes (e.g. from menu open/close)
 * As the map's automatic resizing handles only viewport size changes
 */
const MapResizeListener = () => {
  const { current: mapRef } = useMap();

  useEffect(() => {
    if (mapRef) {
      const mapResize = mapRef.resize;
      const mapContainer = mapRef.getCanvasContainer();

      const resizeObserver = new ResizeObserver(() => {
        mapResize();
      });
      resizeObserver.observe(mapContainer);
      return () => {
        resizeObserver.unobserve(mapContainer);
      };
    }
    return;
  }, [mapRef]);

  return null;
};

export default MapResizeListener;
